export default [
  {
    srno: "1",
    title: "Product Page",
    subtitle: "In publishing and graphic design,",
    description:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate",
    imgurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  },
  {
    srno: "2",
    title: "Product Page",
    subtitle: "In publishing and graphic design,",
    description:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate",
    imgurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  },
  {
    srno: "2",
    title: "Product Page",
    subtitle: "In publishing and graphic design,",
    description:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate",
    imgurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  },
  {
    srno: "2",
    title: "Product Page",
    subtitle: "In publishing and graphic design,",
    description:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate",
    imgurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  }
];
